import { Component, OnInit, Inject, PLATFORM_ID, Input, TransferState, makeStateKey } from '@angular/core'
import { isPlatformServer } from '@angular/common';
import { Title } from '@angular/platform-browser';
import { MktTaggingTransformationService } from '../../../core/services/mkt-tagging-transformation.service';
import { MktSiteCatalystService } from './../../../core/services/mkt-site-catalyst.service';
import { MktContentService } from 'src/app/core/services/mkt-content.service';
import { OfferUtilService } from '../../services/offer-util.service';
import { MktEnvironmentService } from 'src/app/core/services';
const IS_BUNDLE_LOADED_KEY = makeStateKey<boolean>('isBundleLoaded')

@Component({
  selector: 'app-page-not-found',
  templateUrl: './page-not-found.component.html',
  styleUrls: ['../../../../assets/css/errorpage.min.css'],
  standalone: false
})
export class PageNotFoundComponent implements OnInit {

  @Input() siteCateData: any;
  public categoryContent: any = {};
  siteCatalystAllPages: {};
  pageNotFound: boolean;
  environmentPath = ""

  constructor(
    @Inject(PLATFORM_ID) private platformId: string,
    private titleService: Title,
    private _mktTagging: MktTaggingTransformationService,
    private mktSiteCatalystService: MktSiteCatalystService,
    private _mktContentService: MktContentService,
    private _offerUtilService:OfferUtilService,
    private mktEnvironmentService: MktEnvironmentService,
    private _transferState: TransferState,
  ) {
    this._mktContentService.microsite.next(false);
    this.environmentPath = this.mktEnvironmentService.getEnvironmentVar(
          "cardsmkrHostName"
        );
  }

  ngOnInit() {
    this.loadContent();
  }

  commonOnInit(){
    if (isPlatformServer(this.platformId)) {
      this.titleService.setTitle('Citi Credit Cards - Page Not Found');
      this.pageNotFound = true;
    } else {
      this.titleService.setTitle('Citi Credit Cards - Page Not Found');
      this.triggerBAUTagging();
      this.initTaggingTransformationCc();
      this.pageNotFound = true;
    }
  }

  async loadContent(){
    await this._offerUtilService.loadBundleContent({ isBrand:true, isMPP: true });
    this._transferState.get(IS_BUNDLE_LOADED_KEY, false);
    this.commonOnInit();
  }

  private initTaggingTransformationCc() {
    this._mktTagging.tagMktCompareCards('page-not-found', {
      'app_hierarchy' : 'public|enable|oops page not found citicards|landing'
    });
  }

  private triggerBAUTagging() {
    this.siteCatalystAllPages = this._mktContentService.get('Multi_Product_Page', 'copy', 'sitecatalyst-all-pages', undefined);

    let SCInfo = {};
    try{
     SCInfo = JSON.parse(this.siteCatalystAllPages['SCInfo']);
    }catch(e) {
      console.error(e?.message);
    }
    SCInfo['siteSection3'] = "account management";
    this.mktSiteCatalystService.callSC('naAnalyticsPageView', {
      ...SCInfo,
      ...window['citiData'],
      pageName: 'oops page not found',
      eventList: 'custError',
      localpageName: 'oops page not found'
    });
  }
}
